import { useState, useCallback } from 'react';
import { SearchLimitLeftModel } from '@/types/home';
import {
  fetchInstagramAnonymouslyTimesData,
  syncRemainingInstagramAnonymouslyTimesData,
} from '@/lib/service/anonymously';

export type UserUsageModel = SearchLimitLeftModel & {
  first_free_auto_search?: boolean;
  first_free_search?: boolean;
};

const useUserViewerSearchUsageState = () => {
  const [userUsage, setUserUsage] = useState<UserUsageModel>({
    download_limit: 0,
    search_limit: 0,
    un_limit: false,
  });

  // 消耗一次免费查询
  const consumeUserFreeTimes = () => {
    setUserUsage((prev) => {
      return {
        ...prev,
        search_limit: Math.max((prev?.search_limit || 0) - 1, 0),
        first_free_auto_search: false,
        first_free_search: prev?.search_limit >= 1,
      };
    });
  };

  // 获取已登录用户免费次数使用情况
  const fetchTimesRequest = useCallback((callback?: () => void, isLogin?: boolean) => {
    // 未登录时，不检查免费次数使用情况
    if (!isLogin) {
      return;
    }

    fetchInstagramAnonymouslyTimesData(null)
      .then((res) => {
        if (res?.code === 0) {
          setUserUsage(res?.data);
          if (res?.data?.search_limit > 0) {
            callback?.();
          }
        } else {
          setUserUsage(null);
        }
      })
      .catch((error) => {
        setUserUsage(null);
      })
      .finally(() => {});
  }, []);

  // 同步剩余次数
  const syncRemainingTimesData = useCallback((isLogin?: boolean) => {
    if (!isLogin) {
      return;
    }

    syncRemainingInstagramAnonymouslyTimesData(null)
      .then((res) => {
        if (res?.code === 0) {
          setUserUsage((prev) => {
            return {
              ...prev,
              search_limit: 0,
              first_free_search: false,
              first_free_auto_search: true,
            };
          });
        } else {
          setUserUsage(null);
        }
      })
      .catch(() => {});
  }, []);

  return {
    userUsage,
    setUserUsage,
    consumeUserFreeTimes,
    fetchTimesRequest,
    syncRemainingTimesData,
  };
};

export default useUserViewerSearchUsageState;
